import { useCallback, useMemo } from 'react';

import { FEATURE_LIMITS, getFeatureLimitsData } from 'src/data/featureLimits';
import * as events from 'src/lib/events';
import { useTrackingEvent } from 'src/services';
import { useCustomerActions } from 'src/store';

const getFeatureData = (customer) => {
  const featureLimitsData = getFeatureLimitsData(customer, FEATURE_LIMITS.performancePredictions);
  return {
    limit: featureLimitsData?.limit,
    currentCount: featureLimitsData?.currentCount,
  };
};

export const useTrackingEvents = () => {
  const trackEvent = useTrackingEvent();
  const customerActions = useCustomerActions();

  const trackBannerDisplayed = useCallback(() => {
    const customer = customerActions.getCurrentCustomer();
    trackEvent(events.LIMITATIONS.predictionsBannerDisplayed, {
      ...getFeatureData(customer),
    });
  }, [trackEvent, customerActions]);

  const trackUpgradeClicked = useCallback(() => {
    const customer = customerActions.getCurrentCustomer();
    trackEvent(events.LIMITATIONS.predictionsBannerUpgradeClicked, {
      ...getFeatureData(customer),
    });
  }, [trackEvent, customerActions]);

  const trackCloseClicked = useCallback(() => {
    const customer = customerActions.getCurrentCustomer();
    trackEvent(events.LIMITATIONS.predictionsBannerCloseClicked, {
      ...getFeatureData(customer),
    });
  }, [trackEvent, customerActions]);

  return useMemo(
    () => ({ trackBannerDisplayed, trackUpgradeClicked, trackCloseClicked }),
    [trackBannerDisplayed, trackUpgradeClicked, trackCloseClicked]
  );
};
